import React from 'react';
import { Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const useGenerateFormItem = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const assoType = params.get('assoT');

  return (
    resource,
    {
      label,
      name,
      initialValue,
      nameParams,
      dependencies,
      hasFeedback,
      validateStatus,
      rules,
      blocked_activities = false,
      formattedLabel = false,
      input,
      layout,
      noLabel,
      displayLabel = true,
      valuePropName,
      labelAlign,
      withDivider = false,
      help,
      tooltip,
      tooltipName,
      tooltipLabel,
      translate = true,
      hidden = false,
      displayOnly = false,
      show = true,
      prerenderedItem = null,
      warningSublabel = null // Warning (red) text under input's label
    }
  ) => {
    if (prerenderedItem) {
      return prerenderedItem;
    }

    let tooltipText = t(
      `${resource}.form.tooltip.${
        assoType ? label : tooltipName || tooltip?.name || name
      }`,
      tooltip?.params
    );
    if (tooltipLabel) {
      tooltipText = tooltipLabel;
    }

    let display = true;
    if (typeof show === 'boolean') {
      display = show;
    } else if (typeof show === 'function') {
      display = !!show?.();
    } else {
      display = !!show;
    }

    if (!display) {
      return null;
    }

    const getLabel = () => {
      const labelReactNode = [];
      if (displayLabel) {
        labelReactNode.push(
          !noLabel && (blocked_activities || formattedLabel)
            ? label
            : `${
                translate
                  ? t(
                      `${resource}.form.${label || name.join('.')}`,
                      nameParams ? { params: nameParams } : {}
                    )
                  : `${label || name}`
              }`
        );
      }
      if (warningSublabel) {
        labelReactNode.push(
          <span style={{ color: 'var(--secondaryColor)' }}>
            <br />
            {` ${warningSublabel}`}
          </span>
        );
      }
      return labelReactNode;
    };
    return (
      <div key={name}>
        <Form.Item
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...layout}
          labelAlign={labelAlign}
          colon={false}
          hidden={hidden}
          name={displayOnly ? undefined : name}
          initialValue={initialValue}
          dependencies={dependencies}
          label={<div>{getLabel()}</div>}
          hasFeedback={hasFeedback}
          validateTrigger="onBlur"
          rules={rules}
          valuePropName={valuePropName}
          validateStatus={validateStatus}
          help={help}
          tooltip={
            tooltip
              ? {
                  title: tooltipText,
                  styles: {
                    container: { width: 500 }
                  }
                }
              : undefined
          }
        >
          {input || <Input />}
        </Form.Item>
        {withDivider && (
          <Divider
            style={{
              marginBottom: 8,
              marginTop: 0,
              borderTopColor: 'var(--bodyBackground)'
            }}
          />
        )}
      </div>
    );
  };
};

export default useGenerateFormItem;
